const routes = [
    {
        path: "/certificate/center/certificate",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "certificatecentercertificate_index"
        }
    },

];

export default routes;
